import { render, staticRenderFns } from "./privacyJudge.vue?vue&type=template&id=a93308c6&scoped=true"
import script from "./privacyJudge.vue?vue&type=script&lang=js"
export * from "./privacyJudge.vue?vue&type=script&lang=js"
import style0 from "./privacyJudge.vue?vue&type=style&index=0&id=a93308c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93308c6",
  null
  
)

export default component.exports